import globalValues from '@/core/helpers/enums/globalValues';
import store from '@/modules/journeys/store';
import type { RouteLocationNormalizedLoaded } from 'vue-router';

export default class Variables {
   variableToText(text: any, route?: RouteLocationNormalizedLoaded) {
      let isPreviewMode = route ? !!route.query.preview : false;

      let candidateFirstName = isPreviewMode ? 'John' : sessionStorage.getItem(globalValues.candidate.firstName);
      let candidateLastName = isPreviewMode ? 'Doe' : sessionStorage.getItem(globalValues.candidate.lastName);

      let tenantName = sessionStorage.getItem(globalValues.tenant.name);

      let variables = [
         { name: ':candidate_first_name:', replace_with: candidateFirstName },
         { name: ':candidate_last_name:', replace_with: candidateLastName },
         { name: ':customer_name:', replace_with: store.state.journey?.customer ? store.state.journey?.customer.name : '' },
         { name: ':tenant_name:', replace_with: tenantName },
      ];
      let formattedText = text;
      if (text) {
         variables.forEach((variable) => {
            let textToReplace = variable.name;
            let regex = new RegExp(textToReplace, 'g');
            formattedText = formattedText.replace(regex, variable.replace_with ? variable.replace_with : variable.name);
         });
      }

      return formattedText;
   }
}

